var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',_vm._b({attrs:{"dataSource":_vm.data,"pagination":_vm.paginationOptions,"locale":{ emptyText: "Nothing here..." },"scroll":{ x: 1300 }},on:{"change":_vm.onChange}},'a-table',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }